import React from 'react'
import PropTypes from 'prop-types'
import { Radio, Icon, Input } from 'antd'

import { filterArrayBySearchText } from '../../../data/config/utils'

const Search = Input.Search;

class RadioGroupItem extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      show_search_input: false,
      show_all_options: false,
      display_options_count: props.display_count,
      filtered_options: props.options
    }
  }

  showAllOptions = () => {
    const { filtered_options } = this.state;
    this.setState({
      show_all_options: true,
      display_options_count: filtered_options.length,
    });
  }

  showLessOptions = () => {
    const { display_count } = this.props;
    this.setState({
      show_all_options: false,
      display_options_count: display_count,
    });
  }

  showSearchInput = () => {
    this.setState({
      show_search_input: true,
    });
  }

  hideSearchInput = () => {
    const { options } = this.props
    this.setState({
      show_search_input: false,
      filtered_options: options
    });
  }

  onOptionsSearch = event => {
    const { options } = this.props;
    this.setState({
      filtered_options: filterArrayBySearchText(event.target.value, options, 'label')
    })
  }

  render() {
    const { title, container_class, options, show_search, value, onChange } = this.props;
    const { display_options_count, show_all_options, filtered_options, show_search_input } = this.state;
    if (options.length > 0) {
      return (
        <div className={container_class}>
          <div className="ori-flex-row ori-flex-wrap ori-flex-jsb ori-tb-mrgn-5 ori-font-default">
            {
              title &&
              <p className="ori-b-mrgn-5 ori-capitalize-first">{title}</p>
            }
            <div>
              {
                show_search && !show_search_input &&
                <Icon className="ori-r-mrgn-10 ori-cursor-ptr" type="search" onClick={this.showSearchInput} />
              }
              {
                show_search && show_search_input &&
                <Icon className="ori-r-mrgn-10 ori-cursor-ptr" type="close" onClick={this.hideSearchInput} />
              }
            </div>
          </div>
          {
            show_search_input &&
            <Search className="ori-b-mrgn-5" placeholder="search" onChange={this.onOptionsSearch} />
          }
          {
            filtered_options.length === 0 &&
            <span className="ori-font-light ori-font-xs ">Not found</span>
          }
          <Radio.Group className="ori-full-width" value={value} onChange={onChange}>
            {
              filtered_options.map((option, index) => {
                if (index < display_options_count)
                  return (
                    <Radio key={index} className="ori-display-block ori-font-normal" value={option.value}>
                      {option.label}
                    </Radio>
                  );
              })
            }
          </Radio.Group>
          {
            !show_all_options && filtered_options.length > display_options_count &&
            <span className="ori-font-primary ori-cursor-ptr ori-t-mrgn-5 ori-font-xs" onClick={this.showAllOptions}>{`show ${filtered_options.length - display_options_count} more `}</span>
          }
          {
            show_all_options && filtered_options.length >= display_options_count &&
            <span className="ori-font-primary ori-cursor-ptr ori-t-mrgn-5 ori-font-xs" onClick={this.showLessOptions}>show less</span>
          }
        </div>
      );
    } else return null;
  }
}

RadioGroupItem.propTypes = {
  title: PropTypes.string,
  container_class: PropTypes.string,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  display_count: PropTypes.number,
  show_search: PropTypes.bool,
};

RadioGroupItem.defaultProps = {
  container_class: "ori-tb-pad-5",
  options: [],
  onChange: () => { },
  display_count: 6,
  show_search: false,
};

export default RadioGroupItem;



// WEBPACK FOOTER //
// ./src/components/form/radiogroupitem/index.js